export const Score = {
    "最终成绩":"最終成績:",
    "原始成绩":"原始成績:",
    "个人成绩":"個人成績",
    "占比":"占比",
    "成绩未公布":"成績未公布",
    "未公布":"未公布",
    "满分":"滿分",
    "纸":"紙",
    "分数未公布":"分數未公布",
    "搜索学生名学号":"搜索學生名、學號",
    "修改":"修改",
    "的成绩":"的成績",
    "满分100":"滿分100",
    "确认修改":"確認修改",
    "成绩不允许为空且不能超过100":"成績不允許為空且不能超過100",
    "成绩组成":"成績組成",
    "占":"占",
    "的个人成绩":"的個人成績",
    "请输入成绩":"請輸入成績",
    "设置成绩":"設置成績",
    "排名":"排名",
    "课程考核标准":"課程考核標準",
    "暂时还没有总成绩记录":"暫時還沒有總成績記錄",
    "我是学生":"我是學生",
    "成绩详情":"成績詳情",
    "最高分":"最高分",
    "最低分":"最低分",
    "暂时还没有总成绩":"暫時還沒有總成績",
    "请登录":"請登錄",
    "wwwketangpaicom在电脑端设置添加":"www.ketangpai.com，在電腦端設置添加",
    "电脑端在电脑端设置添加":"電腦端，在電腦端設置添加",
}